/**
 * Strongly typed blog item returned from the SimpleBlogList API.
 * @see https://smartdataproxy.azurewebsites.net/api/SimpleBlogList
 */
export interface SimpleBlogItem {
    id: number;
    title: string;
    description: string;
    keywords: string;
    country: string;
    city: string;
    blogUrl: string;
    logoUrl: string;
    contactName: string;
    ownerEMailAddress: string;
    created: Date|null;
    modified: Date|null;
    approved: boolean;
    contentSources: string[];
}

const SIMPLE_BLOG_LIST_API_URL = 'https://smartdataproxy.azurewebsites.net/api/SimpleBlogList';

/**
 * Singleton provider for the SimpleBlogList API.
 * Caches the result; the REST endpoint is only queried when the cache is empty.
 */
export class BlogListProvider {
    private static instance: BlogListProvider;

    /** Cached blog list; null = not yet fetched, array = cached (may be empty). */
    private static items: SimpleBlogItem[] | null = null;

    private constructor() {}

    static getInstance(): BlogListProvider {
        if (!BlogListProvider.instance) {
            BlogListProvider.instance = new BlogListProvider();
        }
        return BlogListProvider.instance;
    }

    /**
     * Gets blogger information from the SimpleBlogList API.
     * Queries the REST endpoint only if the cache is empty;
     * otherwise returns the saved items.
     */
    async GetBloggerInformation(): Promise<SimpleBlogItem[]> {
        if (BlogListProvider.items !== null) {
            return BlogListProvider.items;
        }

        const response = await fetch(SIMPLE_BLOG_LIST_API_URL);
        if (!response.ok) {
            throw new Error(`SimpleBlogList API error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        const items = Array.isArray(data) ? (data as SimpleBlogItem[]) : [];
        BlogListProvider.items = items;
        return items;
    }
}
